import api from "./client";

export type PeriodDays = 7 | 30 | 90;

export interface StatMetric {
  current: number;
  previous: number;
  change_pct: number | null;
}

export interface DashboardChartPoint {
  date: string;
  conversations: number;
  bookings: number;
  revenue: number;
  ai_assisted_revenue?: number;
  ai_assisted_bookings?: number;
}

export interface MissedOpportunitiesMetric extends StatMetric {
  estimated_revenue: number | null;
  estimated_revenue_label: string;
}

export interface SetinImpact {
  bookings_helped_create: number;
  revenue_captured: number;
  after_hours_conversations: number | null;
  after_hours_bookings: number | null;
  calls_handled: number | null;
  calls_created_bookings: number | null;
}

export interface NeedsAttentionItem {
  id: string;
  title: string;
  description: string;
  priority: "high" | "medium" | "low";
  metric_label: string;
  metric_value: number;
  estimated_revenue: number | null;
  estimated_revenue_label: string;
  entity_type: "conversation" | "contact" | "service" | "booking" | "analytics";
  target_url: string | null;
}

export interface DashboardStats {
  period_days: PeriodDays;
  currency: string;
  stats: {
    conversations: StatMetric;
    bookings: StatMetric;
    conversion_rate: StatMetric;
    revenue: StatMetric;
    ai_assisted_revenue?: StatMetric;
    ai_assisted_bookings?: StatMetric;
    average_booking_value?: StatMetric;
    missed_opportunities?: MissedOpportunitiesMetric;
    total_revenue: StatMetric;
    direct_bookings: StatMetric;
  };
  setin_impact?: SetinImpact;
  needs_attention?: NeedsAttentionItem[];
  chart_data: DashboardChartPoint[];
}

export async function fetchDashboardStats(periodDays: PeriodDays): Promise<DashboardStats> {
  const res = await api.get<DashboardStats>("/dashboard/stats", {
    params: { period_days: periodDays },
  });
  return res.data;
}
